module.exports = __webpack_public_path__ + "img/bf.4755cc0e.svg";